<template>
  <div class="fade-in">
    <h1 class="title">Create a User</h1>

    <form @submit.prevent="onSubmit" class="account-form">
      <formly-form :form="form" :model="user" :fields="fields"></formly-form>

      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Create
          </button>
        </div>
        <div class="control">
          <router-link
            :to="{ name: 'user-list', params: { id } }"
            class="button is-link"
            >Cancel
          </router-link>
        </div>
      </div>
    </form>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import PracticesService from "@/services/PracticesService";
import UserFields from "@/components/practice/UserFields";

export default {
  name: "practice-user-create",

  mixins: [UserFields],

  props: ["id"],

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      user: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        roleId: "",
        practiceId: this.id
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      PracticesService.createUser(this.user)
        .then(() => {
          this.loading = false;
          this.$router.push({
            name: "user-list",
            params: { id: this.$props.id }
          });
          this.$refs.toastr.s("The user has been created.");
        })
        .catch(errors => {
          this.loading = false;
          this.setErrors(errors);
          this.$refs.toastr.e("There was an error creating the user.");
        });
    }
  }
};
</script>

<style lang="scss"></style>
